<template>
  <div>
    <h3 class="notice-top">
      产品动态
    </h3>
    <SpFinder
      id="1"
      ref="finder"
      :show-tool-bar="false"
      :no-selection="true"
      class="channelCode"
      :url="{
        data: requestUrl + '/it/site/list?publish_status=1&type=2'
      }"
      :setting="{
        search: [
          {
            type: 'input',
            key: 'title',
            name: '标题',
            size: 'medium',
            placeholder: '请输入标题'
          }
        ]
      }"
      title="数据"
      :columns="columns"
    />
  </div>
</template>

<script>
export default {
  data () {
    const columns = [
      {
        name: '标题', // 表头
        key: 'title', // 匹配data key
        render: (h, { row }) => {
          return (
            <div
              onClick={() => {
                this.handleJump(row.url)
              }}
            >
              {row.tag_title && (
                <el-tag effect='dark' size='mini' type='danger' style={{ marginRight: '8px' }}>
                  {row.tag_title}
                </el-tag>
              )}
              <span>{row.title}</span>
            </div>
          )
        }
      },
      {
        name: '时间', // 表头
        key: 'created_at', // 匹配data key,
        width: '200px'
      }
    ]
    return {
      columns,
      requestUrl: process.env.VUE_APP_BASE_API
    }
  },
  mounted () {},
  methods: {
    handleJump (value) {
      window.open(value, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-top {
  margin-bottom: 10px;
}
.notice-tag {
  margin-right: 8px;
}
</style>
